export const generateUniqueKey = () =>
  `${Math.random().toString(36).substring(2, 10)}-${Date.now()}-${Math.random()
    .toString(36)
    .substring(2, 10)}`;
